export enum TimeToReadRange {
  MIN = 0,
  MAX = 30,
}
